module.exports = __webpack_public_path__ + "img/3.d3383d39.png";